<i18n>
  {
    "pt_BR": {
      "label": "Preview",
      "placeholder": "Preview da sua mensagem.",
      "tips": {
        "label": "Boas práticas",
        "list": [
          "Se a mensagem ultrapassar 160 caracteres, serão enviadas 2 (ou mais) mensagens, que consumirão 2 (ou mais) créditos.",
          "Ao utilizar variáveis, como *|PRIMEIRO_NOME|*, sugerimos que deixe uma margem de segurança de 20 caracteres.",
          "Sugerimos que, sempre que possível, ofereça a opção de opt-out para o usuário: “P/Cancelar, resp SAIR”"
        ]
      }
    }
  }
</i18n>

<template>
  <aside class="new-campaign--sidebar">
    <article class="new-campaign-message--preview">
      <label for="previewMsg" v-t="'label'"></label>

      <p id="previewMsg" class="new-campaign-message--bubble active" :key="index" v-for="(message, index) in splited" v-text="message"></p>
      <p id="previewMsg" class="new-campaign-message--bubble" v-if="body.length <= 0" v-t="'placeholder'"></p>
    </article>

    <article class="new-campaign-sidebar--tips">
      <label for="" v-t="'tips.label'"></label>
      <p class="new-campaign-tip" :key="tip" v-for="tip in $t('tips.list')">
        <span>⚠️</span> {{ tip }}
      </p>
    </article>
  </aside>
</template>

<script>
  export default {
    props: {
      body: {
        type: String,
        required: true,
      },
    },

    computed: {
      splited () {
        const chunks = [];
        const string = this.body;

        for (let i = 0; i < string.length; i += 160) {
          chunks.push(string.substring(i, i + 160));
        }

        return chunks;
      },
    },
  };
</script>



// WEBPACK FOOTER //
// src/components/Campaign/Preview.vue